var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorldicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49164 3.57693H0.515967L0.515936 5.42309L7.49164 5.45805V3.57693ZM0.515977 2.96155L0.515926 6.03847H7.593V2.96155H0.515977Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7.88462C5.86927 7.88462 7.38462 6.36927 7.38462 4.5C7.38462 2.63073 5.86927 1.11538 4 1.11538C2.13073 1.11538 0.615385 2.63073 0.615385 4.5C0.615385 6.36927 2.13073 7.88462 4 7.88462ZM4 8.5C6.20914 8.5 8 6.70914 8 4.5C8 2.29086 6.20914 0.5 4 0.5C1.79086 0.5 0 2.29086 0 4.5C0 6.70914 1.79086 8.5 4 8.5Z",
    fill: "#060606"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98117 7.03667C5.31384 6.41886 5.53846 5.52312 5.53846 4.5C5.53846 3.47688 5.31384 2.58114 4.98117 1.96333C4.63501 1.32045 4.25991 1.11538 4 1.11538C3.74009 1.11538 3.36499 1.32045 3.01883 1.96333C2.68616 2.58114 2.46154 3.47688 2.46154 4.5C2.46154 5.52312 2.68616 6.41886 3.01883 7.03667C3.36499 7.67955 3.74009 7.88462 4 7.88462C4.25991 7.88462 4.63501 7.67955 4.98117 7.03667ZM4 8.5C5.18954 8.5 6.15385 6.70914 6.15385 4.5C6.15385 2.29086 5.18954 0.5 4 0.5C2.81046 0.5 1.84615 2.29086 1.84615 4.5C1.84615 6.70914 2.81046 8.5 4 8.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldicon);
export default __webpack_public_path__ + "static/media/Worldicon.d0f49f7f708fdded49b2708bf5c7c7f6.svg";
export { ForwardRef as ReactComponent };